const initialState = {}

const anamneseReducer = (state = initialState, action) => {
    // console.log('anamneseReducer called with: ', state, action.type, action.payload, { ...state, Daten: action.payload })
    switch (action.type) {
        case 'anamnese/DatenReplaced':
            return { ...state, Daten: action.payload };
        case 'anamnese/NationenReplaced':
            return { ...state, Nationen: action.payload };
        case 'anamnese/Modify':
            // console.log('reducer: Modify called with:', state, action.payload)
            return { ...state, Daten: {...state.Daten, ...action.payload} }
        default:
            return state;
    }
}

export default anamneseReducer;